import { createBrowserRouter, RouteObject } from 'react-router-dom';
import React, { useEffect } from 'react';
import { Home } from '../pages/Home';
import * as MR_OW from '../modules/mrow/CalculatorParams';
import * as CT_OW from '../modules/ctow/CalculatorParams';
import * as IGS_OW from '../modules/igsow/CalculatorParams';
import * as TW_FOR_PETCT from '../modules/tw_petct/CalculatorParams';
import * as TW_FOR_CT from '../modules/tw_ct/CalculatorParams';
import { useCalculatorNavigate } from '../shared/utils/calculatorNavigate';
import { CalculatorMenuParams } from '../shared/classes/CalculatorMenuParams';
import { CalculatorParamsOutlet } from '../shared/contexts/CalculatorParamsOutlet';

export type MenuGroupList = {
    label: string,
    menuList: CalculatorMenuParams[]
};

export const menuGroupList: MenuGroupList[] = [
    {label: 'Computed Tomography (CT)', menuList: [CT_OW.calculatorParams, TW_FOR_CT.calculatorParams]},
    {label: 'Image Guided Solutions (IGS)', menuList: [IGS_OW.calculatorParams]},
    {label: 'MRI', menuList: [MR_OW.calculatorParams]},
    {label: 'Molecular Imaging Product (PETCT)', menuList: [TW_FOR_PETCT.calculatorParams]},
];

function getMenuList(): RouteObject[] {
    return menuGroupList.reduce<RouteObject[]>((prev, curr) => {
        prev.push(...curr.menuList.map(e => e.routes));
        return prev;
    }, []);
}

export const router = createBrowserRouter([
    {
        path: '',
        element: <NavigateToHome/>,
    },
    {
        path: '',
        element: <CalculatorParamsOutlet/>,
        children: getMenuList()
    },
    {
        path: '*',
        element: <NavigateToHome/>
    },
    {
        path: '/',
        element: <NavigateToHome/>
    },
    {
        path: '/home',
        element: <Home/>
    }
]);

function NavigateToHome(): JSX.Element {
    const navigate = useCalculatorNavigate({disablePrefix: true});

    useEffect(() => {
        navigate('home');
    });

    return <></>;
}
